import { ImageOff, Search } from "lucide-react";
import { useMemo, useState } from "react";

import { miniaturaDe } from "@/utils/miniatura";

import { BRL } from "./comum";

/**
 * Lista dos produtos do cardápio com foto, para escolher o prêmio (24/10/2026,
 * dono: "com a foto do produto do cardápio"). Busca pelo nome ou categoria e
 * mostra agrupado por categoria. `pizza` mostra só as pizzas (com tamanhos).
 */
export default function EscolherProduto({ produtos, pizza = false, escolhido, onEscolher }) {
  const [busca, setBusca] = useState("");
  const grupos = useMemo(() => {
    const termo = busca.trim().toLowerCase();
    const lista = produtos.filter((x) => (pizza ? x.tamanhos?.length : !x.tamanhos?.length))
      .filter((x) => !termo || `${x.nome} ${x.categoria}`.toLowerCase().includes(termo));
    const mapa = new Map();
    lista.forEach((x) => { if (!mapa.has(x.categoria)) mapa.set(x.categoria, []); mapa.get(x.categoria).push(x); });
    return [...mapa.entries()];
  }, [produtos, pizza, busca]);

  return (
    <div className="rounded-xl border bg-background overflow-hidden" data-e2e="premio-escolher-produto">
      <div className="relative border-b">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input value={busca} onChange={(e) => setBusca(e.target.value)} autoFocus
          placeholder={pizza ? "Buscar sabor de pizza…" : "Buscar produto do cardápio…"}
          className="w-full h-10 pl-9 pr-3 bg-transparent text-sm outline-none" />
      </div>
      <div className="max-h-72 overflow-y-auto">
        {!grupos.length && <p className="p-4 text-sm text-muted-foreground text-center">Nenhum produto encontrado.</p>}
        {grupos.map(([categoria, itens]) => (
          <div key={categoria}>
            <p className="px-3 pt-2.5 pb-1 text-[10px] font-bold uppercase tracking-wider text-muted-foreground">{categoria}</p>
            {itens.map((x) => (
              <button key={x.id} type="button" onClick={() => onEscolher(x)} data-e2e="premio-produto-opcao"
                className={`w-full flex items-center gap-3 px-3 py-2 text-left hover:bg-muted/60 ${x.id === escolhido ? "bg-primary/10" : ""}`}>
                {x.foto
                  ? <img src={miniaturaDe(x.foto, 128)} alt="" loading="lazy" className="w-10 h-10 rounded-lg object-cover bg-muted shrink-0" />
                  : <span className="w-10 h-10 rounded-lg bg-muted grid place-items-center shrink-0"><ImageOff className="w-4 h-4 text-muted-foreground" /></span>}
                <span className="min-w-0 flex-1 text-sm font-medium truncate">{x.nome}</span>
                <span className="text-xs text-muted-foreground tabular-nums shrink-0">
                  {pizza ? `${x.tamanhos.length} ${x.tamanhos.length === 1 ? "tamanho" : "tamanhos"}` : BRL(x.preco)}
                </span>
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
